import React, { useState } from "react";
import "./BuildTogether.css";
import { useNavigate } from "react-router-dom";

export default function BuildTogether() {
    const navigate = useNavigate();
  const [active, setActive] = useState(0);

  const faqData = [
    {
      question: "Donec rutrum congue leo eget malesuada?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sapien, dignissim tristique tellus sed faucibus nullam."
    },
    {
      question: "Vivamus suscipit tortor eget felis porttitor volutpat?",
      answer:
        "Curabitur non nulla sit amet nisl tempus convallis quis ac lectus."
    },
    {
      question: "Curabitur non nulla sit amet nisl tempus?",
      answer:
        "Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a."
    },
    {
      question: "Pellentesque in ipsum id orci porta dapibus?",
      answer:
        "Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui."
    },
    {
      question: "Curabitur non nulla sit amet nisl?",
      answer:
        "Donec sollicitudin molestie malesuada."
    }
  ];

  const toggle = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section className="dd-build-section">

      <div className="dd-build-container">

        {/* LEFT SIDE */}
        <div className="dd-build-left">

          <h3>Let's Build <br /> Something Together</h3>

          <div className="dd-build-line"></div>

          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Sapien, dignissim tristique tellus sed faucibus nullam.
            Tincidunt mauris ut quam sed mauris proin feugiat.
          </p>

          <button className="dd-build-btn" onClick={() => navigate("/#contact")}>
            GET IN TOUCH
          </button>

        </div>

        {/* RIGHT SIDE */}
        <div className="dd-build-right">

          {faqData.map((item, index) => (

            <div
              key={index}
              className={`dd-faq-item ${active === index ? "active" : ""}`}
            >

              <div
                className="dd-faq-question"
                onClick={() => toggle(index)}
              >

                {item.question}

                <span className="dd-faq-icon">
                  {active === index ? "−" : "+"}
                </span>

              </div>

              {active === index && (
                <div className="dd-faq-answer">
                  {item.answer}
                </div>
              )}

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}